/**
 *
 * Asynchronously loads the component for PracticeMessages
 *
 */

import loadable from "@loadable/component";

export default loadable(() => import("./PracticeMessages"));
